import React from 'react';

function OptionsComponent({ option, index, currentQuestionObj, handleCheckbox, isChecked, activeOption, handleOptionSelect, finalResultJson }) {
    return (
        currentQuestionObj.questionType === "MAQ" ?
            <div key={index + currentQuestionObj.qid} className='p-3 m-1 border rounded '
                onClick={() => {
                    handleCheckbox(option, currentQuestionObj.qid, currentQuestionObj.questionType)
                }
                }
                style={isChecked(currentQuestionObj.qid, option) ?
                    { display: "flex", backgroundColor: "cadetblue", color: "antiquewhite" } : { display: "flex" }}>
                <input className='form-check-input' type="checkbox" name='option' onChange={() => { }} checked={isChecked(currentQuestionObj.qid, option)} />
                <label className=' ms-4'>{option.optionValue}</label>
            </div>
            :
            <div key={index + currentQuestionObj.qid} className='p-3 m-1 border rounded'
                onClick={() => handleOptionSelect(option, currentQuestionObj.qid, currentQuestionObj.questionType)}
                style={finalResultJson.some(e => e.qid === currentQuestionObj.qid && e.selectedOption === option) ? {
                    display: "flex", backgroundColor: "cadetblue", color: "antiquewhite"
                } : { display: "flex" }}>
                <label className=' ms-4 ps-3 pe-3'>
                    {option.optionValue}
                </label>
            </div>
    )
}

export default OptionsComponent